import React from 'react';
import InputField from '../../../../../../component/form/FormInput';
import PageLoader from '../../../../../../component/PageLoader';

export default function SalesOrderGeneral({ setForm, form, error, setError, loader }) {
	const handleFormData = (key, value) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};
	return (
		<div>
			{loader.isGetData && loader.isLoader ? (
				<PageLoader />
			) : (
				<div className="p-3">
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Terms & Conditions</div>
						<div className="col-8 col-xl-6 my-2">
							<InputField
								type="text"
								value={form?.terms_and_conditions}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('terms_and_conditions', value)}
								error={error?.terms_and_conditions}
								required
								autoComplete="new-password"
							/>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Customer Notes</div>
						<div className="col-8 col-xl-6 my-2">
							<InputField
								type="text"
								value={form?.customer_notes}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('customer_notes', value)}
								error={error?.customer_notes}
								required
								autoComplete="new-customer-notes"
							/>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Additional Charge Fields</div>
						<div className="col-8 col-xl-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.additional_charge_fields}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData('additional_charge_fields', !form.additional_charge_fields)
									}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Round Off Preferences</div>
						<div className="col-6 my-2">
							<div className="d-flex gap-4 align-items-center">
								<label className="d-flex gap-3 py-2 cursor-pointer">
									<input
										type="radio"
										className="custom-radio"
										checked={form.round_off_preferences === 'up'}
										onChange={() => handleFormData('round_off_preferences', 'up')}
									/>
									{'Round Up'}
								</label>
								<label className="d-flex gap-3 py-2 cursor-pointer">
									<input
										type="radio"
										name="round"
										className="custom-radio"
										checked={form.round_off_preferences === 'down'}
										onChange={() => handleFormData('round_off_preferences', 'down')}
									/>
									Round Down
								</label>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Enable Salesperson</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.enable_salesperson}
									id="flexCheckDefault"
									onChange={(e) => handleFormData('enable_salesperson', !form.enable_salesperson)}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
